import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { CircleCheckBig } from "lucide-react";
import axiosInstance from "../../../services/axiosInstance";
import { clearSession } from "../../../utils/clearSession";

const TeamPricingCard = () => {
  const navigate = useNavigate();
  const [cardDetails, setCardDetails] = useState([]);

  const getPricing = async () => {
    const country = "UAE";
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getPricing}/${country}`
      );

      if (res.data.status === false) {
        clearSession();
      } else {
        setCardDetails(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching pricing:", error);
    }
  };

  useEffect(() => {
    getPricing();
  }, []);

  return (
    <Box sx={{ p: 3, mt: 2, display: "flex", justifyContent: "center" }}>
      <Grid container spacing={3} justifyContent="center">
        {cardDetails.map((e, i) => (
          <Grid key={e._id || i} item xs={12} sm={6} md={3.3}>
            <Card
              sx={{
                maxWidth: 320,
                width: "100%",
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "scale(1.05)" },
                borderRadius: 6,
                border: "1px solid #EEEEEE",
              }}
            >
              <CardContent sx={{ p: 5 }}>
                <Typography variant="h6" sx={{ fontWeight: 900, mb: 2 }}>
                  {e.title}
                </Typography>

                <Box sx={{ mb: 0 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 100,
                      color: "grey",
                      textDecoration: "line-through",
                      display: "inline-flex",
                      alignItems: "baseline",
                    }}
                  >
                    AED {Math.floor(e.price)}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontSize: "1rem", ml: 1, color: "grey" }}
                  >
                    /mo
                  </Typography>
                </Box>

                <Box sx={{ mb: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "28px",
                      fontWeight: "bold",
                      display: "inline-flex",
                      alignItems: "baseline",
                    }}
                  >
                    AED {Math.floor(e.offer_price)}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontSize: "1rem", ml: 1, color: "text.secondary" }}
                  >
                    /mo
                  </Typography>
                </Box>

                <List sx={{ mt: 0 }}>
                  {e.features?.map((feature, idx) => (
                    <ListItem key={idx} sx={{ px: 0, py: 1 }}>
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <CircleCheckBig color="#6366f1" strokeWidth={3} />
                      </ListItemIcon>
                      <ListItemText
                        primary={feature.title}
                        sx={{
                          "& .MuiListItemText-primary": {
                            fontSize: "0.95rem",
                            color: "text.secondary",
                            fontWeight: 600,
                          },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    m: "10px 0",
                    py: 1.5,
                    textTransform: "none",
                    borderRadius: 2,
                    backgroundColor: "#1a237e",
                    "&:hover": {
                      backgroundColor: "#0d47a1",
                    },
                  }}
                  onClick={() => navigate(`/bill-details/${e._id}`)}
                >
                  Get started
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TeamPricingCard;
